import React, {useMemo, useState} from 'react';
import {FormInputComponent} from "../../../components/form/Form";
import {InputNumber, Radio, Space} from "antd";
import {usePositionForm} from "../../../providers/PositionFormProvider";
// import { useAuth } from "../../../providers/AuthProvider";
import {useOutletContext} from "react-router-dom";
import TalentAverageBill from "../../talent-application/components/TalentAverageBill";
import UserDiscipline from "../../../models/UserDiscipline";
import {useProjectForm} from "../../../providers/ProjectFormProvider";

const PositionTimeMaterialsForm = props => {
    // const { auth } = useAuth();
    const {project} = useProjectForm();

    const {
        formModel: position,
        isProjectUpdating,
        onFormReset,
        onFormChange
    } = usePositionForm();

    const positionMarkup = position.percent_markup || project.percent_markup || 0

    const [showCustomBillRate, setShowCustomBillRate] = useState(() => !!position.target_rate ? 1 : 0);

    const { onChange, isReadOnly, isDisabled } = useOutletContext();


    const positionRate = useMemo(() => {
        if (position.target_rate) return position.target_rate;

        return TB.max(
            TB.map(position.disciplines, dis => {
                return UserDiscipline.rateForDiscipline(dis.id, parseFloat(positionMarkup), true)
            }
        ))
    }, [position.disciplines, position.target_rate, positionMarkup])

    const [typeOfSpending, setTypeOfSpending] = useState(() => {
        return position?.budget > 0 ? "budget" : "avg_hours_per_period"
    })


    return (
        <div className="position-timing-pricing-structure flex flex-col justify-start items-stretch self-stretch relative">

            <div className="mb-8 flex flex-col gap-4">

                <div className="flex items-center justify-between">
                    {!props.isReadOnly && (
                        <p className="text-lg font-medium text-left text-[#3f434a]">
                            {/* Timing */}
                            What's your approximate budget?
                        </p>
                    )}

                    <Radio.Group
                        className=""
                        disabled={isDisabled || isProjectUpdating}
                        optionType="button"
                        buttonStyle="solid"
                        onChange={e => setTypeOfSpending(e.target.value)}
                        value={typeOfSpending}
                    >
                        <Radio value="avg_hours_per_period" className="h-[unset] text-center p-0.5 w-[150px]">
                            <span className="text-sm font-semibold">
                                By Hours
                            </span>
                        </Radio>
                        <Radio value="budget" className="h-[unset] text-center p-0.5 w-[150px]">
                            <span className="text-sm font-semibold">
                                By Total Spend
                            </span>
                        </Radio>

                    </Radio.Group>
                </div>


                <div className="pt-1">

                    {typeOfSpending === "avg_hours_per_period" && (

                        <div className="flex items-center gap-6">

                            <FormInputComponent
                                fieldName="avg_hours_per_period"
                                value={position.avg_hours_per_period}
                                label={false}
                                isReadOnly={props.isReadOnly}
                                type="antd-input"
                                invalidStyles={{ height: '0' }}
                                className="mb-0"
                                disabled={isDisabled || isProjectUpdating || typeOfSpending !== "avg_hours_per_period"}
                                required={typeOfSpending === "avg_hours_per_period"}
                                min={1}
                                validation={{
                                    rules: {
                                        isInt: true,
                                        matchRegexp: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/
                                    },
                                    errors: {
                                        matchRegexp: `Must be greater than 0`
                                    }
                                }}
                            >

                                <InputNumber
                                    className="[&>.ant-input-number-input-wrap]:w-24"
                                    // pattern={/\b([1-9]|[1-3][0-9]|40)\b/}
                                    placeholder="1-40 hrs"
                                    addonAfter={<p>Hours per week for the duration above</p>}
                                    required={true}
                                    controls={false}
                                />
                            </FormInputComponent>

                            {/* <p className="text-sm avg-bill-alert py-1 px-1.5">~800 total hours</p> */}

                            {position.calculatedTotalHours() && (
                                <p className="text-sm avg-bill-alert py-1 px-1.5 mb-[3px]">~{position.calculatedTotalHours()} total hours</p>
                            )}
                        </div>


                    )}

                    {typeOfSpending === "budget" && (
                        <div className="flex">

                            <FormInputComponent
                                fieldName="budget"
                                value={position.budget}
                                isReadOnly={isReadOnly}
                                label={false}
                                className="mb-0"
                                type="antd-input"
                                required={typeOfSpending === "budget"}
                                placeholder="0.00"
                                min={0}
                                max={1000000}
                                validation={{
                                    rules: {
                                        isInt: true,
                                        min(values, value) {
                                            if (!TB.isDefined(value)) return true;

                                            return parseInt(value) >= 0
                                        },
                                        max(values, value) {
                                            if (!TB.isDefined(value)) return true;
                                            return parseInt(value) <= 1000000;
                                        },
                                    },
                                    errors: {
                                        min: `The role budget must be greater than $0.00`,
                                        max: `The role budget must be less than $1,000,000.00`,
                                    }
                                }}
                                disabled={isProjectUpdating || isDisabled || typeOfSpending !== "budget"}
                            >
                                <InputNumber
                                    controls={false}
                                    className="[&>.ant-input-number-input-wrap]:w-24"
                                    // className="w-full"
                                    addonAfter={<p>My total budget for this position</p>}
                                    addonBefore="$"
                                    required={false}
                                />
                            </FormInputComponent>
                        </div>
                    )}

                </div>

                <hr className="self-stretch w-full" />


                <p className="text-lg font-medium text-left text-[#3f434a] pt-1">
                    What bill rate do you want to use as part of the budget for this position?
                </p>

                <div className="">

                    <Radio.Group
                        onChange={async(e) => {
                            console.log('e.', e.target.value);
                            await setShowCustomBillRate(e.target.value);
                            if (e.target.value === 0) {
                                onFormChange({target_rate_is_visible: null,target_rate: null,max_rate: null})
                            }
                        }}
                        value={showCustomBillRate}
                    >
                        <Space direction="vertical">
                            <Radio value={0}>
                                {/* <span className="text-sm"><strong>{TB.formatCurrency(positionRate)} per hour - the average rate on Wripple for the selected </strong></span> */}
                                <TalentAverageBill
                                    timingLayout
                                    disciplines={position.disciplines}
                                    hourlyMarkUp={parseFloat(positionMarkup)}
                                    forClient={true}
                                />
                            </Radio>

                            <Radio value={1}>
                                <span className="text-sm">I have a specific bill rate I want to use</span>
                            </Radio>
                        </Space>
                    </Radio.Group>

                    {!!showCustomBillRate && (
                        <div className="pt-6">

                            <div className="flex flex-col gap-4 w-full items-start">
                                <div className="w-1/2">
                                    <FormInputComponent
                                        fieldName="target_rate"
                                        value={position.target_rate}
                                        type="antd-input"
                                        disabled={isProjectUpdating || isDisabled}
                                        isReadOnly={props.isReadOnly}
                                        placeholder="--"
                                        min={1}
                                        max={5000}
                                        validation={{
                                            rules: {
                                                // isInt: true,
                                                min(values, value) {
                                                    return !TB.isDefined(value) || Number(value) >= 0
                                                },
                                                max(values, value) {
                                                    return !TB.isDefined(value) || Number(value) <= 5000
                                                }
                                            },
                                            errors: {
                                                min: `The target bill rate must be greater than $0.00`,
                                                max: `The target bill rate must be less than $5000`
                                            }
                                        }}
                                        label={'The target bill rate I expect to pay for this position'}
                                        required={false}
                                    >
                                        <InputNumber
                                            className="w-full"
                                            controls={false}
                                            // bordered={!props.isReadOnly}
                                            addonAfter=" per hour "
                                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        />
                                    </FormInputComponent>

                                    <FormInputComponent
                                        fieldName="target_rate_is_visible"
                                        value={position.target_rate_is_visible}
                                        isReadOnly={props.isReadOnly}
                                        label={(<span className="whitespace-no-wrap">Yes, this target bill rate can be shared with interested candidates</span>)}
                                        type="checkbox"
                                        required={false}
                                    />
                                </div>

                                <div className="w-1/2">
                                    <FormInputComponent
                                        fieldName="max_rate"
                                        value={position.max_rate}
                                        type="antd-input"
                                        disabled={isProjectUpdating || isDisabled}
                                        isReadOnly={props.isReadOnly}
                                        placeholder="--"
                                        // min={1}
                                        min={((TB.isDefined(position.target_rate) ? Number(position.target_rate) : undefined) || undefined)}
                                        max={5000}
                                        validation={{
                                            rules: {
                                                // isInt: true,
                                                min(values, value) {
                                                    if (!TB.isDefined(value)) return true;

                                                    console.log(Number(value), position.target_rate, 'position.target_rate')

                                                    return Number(value) >= (TB.isDefined(position.target_rate) ? position.target_rate : 0)
                                                },
                                                max(values, value) {
                                                    if (!TB.isDefined(value)) return true;
                                                    return Number(value) <= 5000;
                                                },
                                            },
                                            errors: {
                                                min: `The maximum bill rate must be greater than ${TB.isDefined(position.target_rate) ? 'the target bill rate' : '$0.00'}`,
                                                max: `The maximum bill rate must be less than $5000`
                                            }
                                        }}
                                        label={'The maximum bill rate I could pay for this position'}
                                        required={false}
                                    >
                                        <InputNumber
                                            className="w-full"
                                            controls={false}
                                            // bordered={!props.isReadOnly}
                                            addonAfter=" per hour "
                                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        />
                                    </FormInputComponent>
                                    <p className="text-xs text-[#666] pt-[5px]">
                                        Note: Your maximum bill rate <span className="underline">will not</span> be shared with
                                        candidates
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                </div>


                <div className="mt-4 bg-gray-50 flex flex-col justify-start items-center self-stretch relative gap-5 py-5 px-8 border">
                    <div>
                        <p className="text-2xl font-medium text-center text-[#3f434a]">Summary</p>
                        <p className="text-center text-[#3f434a]">My initial budget for this position</p>
                    </div>

                    <div className="flex w-full gap-4">
                        <div className="w-full text-center">
                            <p className="pb-2">Estimated Total Cost</p>
                            <p className="avg-bill-alert font-semibold py-1 px-1.5">
                                {position.calculatedTotalHours() ? TB.formatCurrency(positionRate * position.calculatedTotalHours(), false) : '$0.00'}
                            </p>
                        </div>
                        <div className="w-full text-center">
                            <p className="pb-2">Hours Per Week</p>
                            <p className="avg-bill-alert font-semibold py-1 px-1.5">
                                {position.avg_hours_per_period || '-'}
                            </p>
                        </div>
                        <div className="w-full text-center">
                            <p className="pb-2">Total Hours</p>
                            <p className="avg-bill-alert font-semibold py-1 px-1.5">
                                {position.calculatedTotalHours() || '-'}
                            </p>
                        </div>
                        <div className="w-full text-center">
                            <p className="pb-2">Bill Rate</p>
                            <p className="avg-bill-alert font-semibold py-1 px-1.5">
                                {positionRate ? TB.formatCurrency(positionRate) : '$0.00'} per hr
                            </p>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    );
};

PositionTimeMaterialsForm.propTypes = {};

export default PositionTimeMaterialsForm;